module.exports = __webpack_public_path__ + "img/GH-kyujin-website001.c15c83fc.webp";